export default __webpack_public_path__ + "static/media/previous.54e01559.svg";